import { Appointment, EndDepartureDto } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";
import { appointmentApi } from "../service";
import { auditLogKeys } from "../../../audit-log";

/** "Abfahrt beenden" — closes the departure phase and releases the work session. */
export function useEndAppointmentDeparture() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, dto, workOrderId }: { id: number; dto: EndDepartureDto; workOrderId?: string }) => {
      const { data } = await appointmentApi.endDeparture(id, dto);
      return { appointment: data as Appointment, workOrderId };
    },
    onSettled: (_data, _err, vars) => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      // Closing the departure re-derives the occupied block (actual departure wins).
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      if (vars?.workOrderId) {
        queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(vars.workOrderId) });
      }
    },
  });
}
